<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="The Characters">
<p class="head" id="tc"><a href="#/text/nav#R_tc"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><i>The Characters</i></span></a></p>
<p class="sub1"><i>The Fallen</i></p>
<p class="hang"><b>Lucifer:</b> <i>Satan,</i> King of Perdition. Tempter; Adversary; Sovereign Ruler of the race of men, Earth, and the nether regions.</p>
<p class="hang"><b>Charsoc:</b> Dark Apostle. Chief High Priest of the Fallen; Governor of the Grand Wizards of the Black Court and the dreaded Warlock Kings of the West.</p>
<p class="hang"><b>Marduk:</b> Head of the Darkened Councils and Lucifer’s Chief of Staff.</p>
<p class="hang"><b>Darsoc:</b> Princeling of legion of Grey Magi.</p>
<p class="hang"><b>Lord Astaroth:</b> Michael’s ex-general. Lucifer’s commander-in-chief and Grand Duke of Perdition.</p>
<p class="hang"><b>Moloch:</b> Satanic prince. ‘Butcher’ of Perdition.</p>
<p class="hang"><b>Dagon:</b> Commander of the Black Horde.</p>
<p class="hang"><b>Folcador</b>: Grand Duke of Hell.</p>
<p class="hang"><b>Merodach:</b> Satanic regent of the kingdom of Babylonia.</p>
<p class="hang"><b>Gaap:</b> King of the Western Region of Hell. Chief elder of the underlords.</p>
<p class="hang"><b>Nisroc the Ancient:</b> Keeper of Death and the Grave.</p>
<p class="hang"><b>Nakan:</b> Warlock King of the Necromancers of the East.</p>
<p class="hang"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><b>Dracul:</b> Ruler of Warlock Kings of the West.</span></p>
<p class="hang"><b>Sethunelah:</b> Ancient leader of the Dark Grey Magi.</p>
<p class="hang"><b>Huldah:</b> Dark Overlord of the Shaman Kings.</p>
<p class="hang"><b>Dagda:</b> Newly crowned Ruler of the Necromancer Kings.</p>
<p class="hang"><b>Failenn:</b> Queen of the Demon Witches.</p>
<p class="hang"><b>Balberith:</b> Lucifer’s chief attendant.</p>
<p class="hang"><b>Zadkiel:</b> Lucifer’s aide. Banished to Tartarus, the Abyss.</p>
<p class="hang"><b>Ramuel and Mulciber:</b> Generals of the Black Horde.</p>
<p class="sub1"><i>Dread Councils of Hell</i></p>
<p class="hang"><b>The Dread Warlocks of Ishtar.</b></p>
<p class="hang"><b>Archangels of Astaroth.</b></p>
<p class="hang"><b>Thrones of Folcador.</b></p>
<p class="hang"><b>Black Magi.</b></p>
<p class="hang"><b>The Necromancer Kings.</b></p>
<p class="hang"><b>Demon Witches.</b></p>
<p class="hang"><b>Hera and the Banshees of Valkyrie.</b></p>
<p class="hang"><b>Shaman Kings.</b></p>
<p class="hang"><b>The Wort Seers of Diabolos.</b></p>
<p class="sub1"><i>First Heaven</i></p>
<p class="hang"><b>Michael:</b> Chief Prince of the Royal House of Yehovah. Commander-in-chief of First Heaven’s armies; President of the warring councils.</p>
<p class="hang"><b>Gabriel:</b> Chief Prince of the Royal House of Yehovah. Lord Chief Justice of angelic Revelators.</p>
<p class="hang"><b>Yehovah:</b> Ancient of Days.</p>
<p class="hang"><b>Christos:</b> Jesus.</p>
<p class="hang"><b>Jether:</b> Imperial warrior; Ruler of the twenty-four ancient monarchs of the First Heaven and High Council Chief Steward of Yehovah’s sacred mysteries.</p>
<p class="hang"><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix"><b>Xacheriel:</b> Ancient of Days, Curator of the sciences and universes; one of the twenty-four ancient kings under Jether’s governance.</span></p>
<p class="sub1"><i>High Ruling Council of Angelic Elders</i></p>
<p class="hang"><b>Jether, Xacheriel.</b></p>
<p class="hang"><b>Maheel, Lamaliel.</b></p>
<p class="hang"><b>Issachar, Zebulon.</b></p>
<p class="hang"><b>Jehosaphat, Methuselah.</b></p>
<p class="hang"><b>Raphael:</b> Lucifer’s ex-commander-in-chief. Michael’s leading general.</p>
<p class="hang"><b>Ephaniah:</b> Lucifer’s ex-manservant.</p>
<p class="hang"><b>Uriel, Ariel</b></p>
<p class="hang"><b>Adam:</b> First-born of the race of men.</p>
<p class="hang"><b>Younglings:</b> An ancient angelic race with the characteristics of eternal youth and a remarkable inquisitiveness, expressly designed as apprentices to assist the Ancient Ones in their custodianship of Yehovah’s countless new galaxies.</p>
<p class="hang"><b>Obadiah, Dimnah.</b></p>
<p class="hang"><b>Tirzah, Rakkon.</b></p>
<p class="hang"><b>Otniel, Jatir.</b></p>
<p class="hang"><b>Lamech, Kalleel.</b></p>
<p class="sub1"><i>Earth: 2021</i></p>
<p class="hang"><b>Jotapa:</b> (22), Princess of Jordan.</p>
<p class="hang"><b>Nick De Vere:</b> (29), youngest brother, De Vere dynasty. Archaeologist; dying of Aids.</p>
<p class="hang"><b>Adrian De Vere:</b> (40), middle brother, De Vere dynasty. Former prime minister of the United Kingdom; newly <span class="right_1" epub:type="pagebreak" id="page_x" title="x">appointed President of the United States of Europe; Nobel Peace Prize nominee.</span></p>
<p class="hang"><b>Jason De Vere:</b> (44), eldest brother: De Vere dynasty. US media tycoon; owns a third of the Western world’s television and newspaper empires.</p>
<p class="hang"><b>Julia St Cartier:</b> (42), Jason De Vere’s ex-wife.</p>
<p class="hang"><b>Lily De Vere:</b> (15), Julia and Jason’s daughter. Crippled.</p>
<p class="hang"><b>Lilian De Vere:</b> (76), Nick, Adrian and Jason De Vere’s mother.</p>
<p class="hang"><b>Lawrence St Cartier:</b> (82), Jesuit priest; retired CIA; antiquities dealer. Julia St Cartier’s uncle.</p>
<p class="sub1"><i>Earth: <span class="small">AD</span> 28</i></p>
<p class="hang"><b>The Nazarene:</b> Jesus.</p>
<p class="hang"><b>Aretas:</b> King of Arabia/Petra.</p>
<p class="hang"><b>Jotapa:</b> Princess of Arabia.</p>
<p class="hang"><b>Zahi:</b> Crown Prince of Arabia.</p>
<p class="hang"><b>Ayeshe:</b> Aretas’ manservant.</p>
<p class="hang"><b>Duza:</b> Zahi’s bearer.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310096153_The_Characters.vue?70e00983